import { Modal } from '@veneer/core';
import styled from 'styled-components';

import { layout, mobile, tablet } from '../../GlobalStyles';

const { size5, size7 } = layout;

export const CustomModal = styled(Modal)`
  padding: 48px 40px !important;
  max-width: 824px !important;
  min-width: 824px !important;

  ${tablet} {
    padding: 44px 36px !important;
    max-width: 622px !important;
    min-width: unset !important;
  }

  ${mobile} {
    padding: ${size7}px ${size7}px ${size7}px ${size5}px !important;
    max-width: unset !important;
    min-width: 382px !important;
  }
`;
